// /src/wsRecovery/sleepyTick.js

// English comments only in this code block

let tickInterval = null;
let lastTime = null;

/**
 * Start sleepy tick detection.
 * @param {function} onWake - called when a sleep/wake or tab freeze is detected
 * @param {number} intervalMs - normal tick interval (default: 5000ms)
 * @param {number} thresholdMs - max allowed gap before detecting sleep (default: interval*2)
 */
export function startSleepyTick(onWake, intervalMs = 5000, thresholdMs = intervalMs * 2) {
  if (tickInterval) return;

  lastTime = Date.now();

  tickInterval = setInterval(() => {
    const now = Date.now();
    const gap = now - lastTime;

    // English comment: if gap is too large, browser was frozen or in sleep mode
    if (gap > thresholdMs) {
        console.log(
            `[sleepyTick] 💤 Wake detected – gap=${gap}ms (expected max=${thresholdMs}ms)`
        );

      onWake?.({ type: "wake", gap });
    }

    lastTime = now;
  }, intervalMs);
}

/**
 * Stop sleepy tick detection
 */
export function stopSleepyTick() {
  if (tickInterval) {
    clearInterval(tickInterval);
    tickInterval = null;
  }
}
